<div class="spinner-overlay">
  <div class="spinner-content">
    <img src="assets/spinner.png" alt="Cargando..." class="spinner-img" />
    <div class="spinner-text">{{ texto }}</div>
  </div>
</div>
